import { Injectable } from '@angular/core';
import { DbContext, DbTable } from '../data/dbcontext.service';
import { HttpClient } from '@angular/common/http';
import { DateService } from '../date/date.service';
import { DateParserService } from '../daily-log/daily-log-time/date-parser-service';
import { PtLuxonDate } from '../../models/projects/date.models';
import { Observable } from 'rxjs/Observable';
import { ConsumableEditor } from '../../models/consumables/consumables.models';
import { TimeZoneService } from '../time-zone/time-zone.service';
import { AppConfig } from '../../app/app.config';
import { cloneDeep } from 'lodash';

@Injectable()
export class ConsumablesService {
  config = AppConfig.settings;
  private readonly consumableTable: DbTable;

  constructor(
    private http: HttpClient,
    private dbContext: DbContext,
    private dateService: DateService,
    private dateParserService: DateParserService,
    private timeZoneService: TimeZoneService
  ) {
    this.consumableTable = this.dbContext.tables.find(t => t.name === 'ConsumableData');
  }

  // note that res.date has not been deserialised here, as all we need is the id
  async saveEditor(editor: ConsumableEditor): Promise<ConsumableEditor> {
    const editorToSave = cloneDeep(editor);
    editorToSave.date.dateTime = await this.dateParserService.removeOffsetFromLuxonDate(editorToSave.date.dateTime);
    const url = `${this.config.apiUrl}api/consumables/save`;
    return this.http.post<ConsumableEditor>(url, editorToSave).toPromise();
  }

  deleteAllConsumableRecords() {
    return this.dbContext.removeAll(this.consumableTable);
  }

  async saveConsumableChangeMultipleRecords(records: ConsumableEditor[]) {
    for (let i = 0; i < records.length; i++) {
      const recordToStore = cloneDeep(records[i]);
      await this.dbContext.addOrUpdate(this.consumableTable, recordToStore.id, recordToStore);
    }
  }

  async getConsumableDataForDay(ptLuxonDate?: PtLuxonDate): Promise<ConsumableEditor> {
    let instances = await this.dbContext.getAll(this.consumableTable) as ConsumableEditor[];
    instances = await this.applyOffsetsToConsumableTimes(instances);

    const filteredInstances: ConsumableEditor[] = [];

    for (let i = 0; i < instances.length; i++) {
      const sameDay = await this.dateService.compareDayOffsetsPreApplied(ptLuxonDate.dateTime, instances[i].date.dateTime);
      if (sameDay) {
        filteredInstances.push(instances[i]);
      }
    }

    let consumables = filteredInstances[0];

    if (!!consumables) {
      return cloneDeep(consumables);
    }

    consumables = new ConsumableEditor();
    consumables.date = ptLuxonDate;

    return consumables;
  }

  validate(editor: ConsumableEditor): Observable<void> {
    const editorToValidate = cloneDeep(editor);
    editorToValidate.date.dateTime = this.dateParserService.removeOffsetFromLuxonDate(editorToValidate.date.dateTime);
    const url = `${this.config.apiUrl}api/consumables/validate`;
    return this.http.post<void>(url, editorToValidate);
  }

  async applyOffsetsToConsumableTimes(
    instances: ConsumableEditor[],
  ): Promise<ConsumableEditor[]> {
    for (let i = 0; i < instances.length; i++) {
      if (instances[i].date) {
        instances[i].date.dateTime = await this.dateParserService.deserializeDate(instances[i].date.dateTime, true, this.timeZoneService);
      }
    }

    return instances;
  }
}



// WEBPACK FOOTER //
// ./src/services/consumables/consumables.service.ts